import React from 'react';

const TelegramIcon: React.FC = () => {
  return (
    <div className="telegram-icon-container">
      <a
        href="https://t.me/ctquynhnhu"
        target="_blank"
        rel="noopener noreferrer"
        className="telegram-link"
        aria-label="Telegram"
      >
        <img
          src="/assets/tele-icon.png"
          alt="Telegram"
          className="social-icon telegram-icon"
        />
      </a>
      
      <style dangerouslySetInnerHTML={{
        __html: `
          .telegram-icon-container {
            position: fixed;
            bottom: 20px;
            left: 20px;
            z-index: 1000;
          }
          
          .telegram-link {
            display: block;
            transition: transform 0.3s ease;
          }
          
          .telegram-link:hover {
            transform: scale(1.1);
          }
          
          .social-icon {
            width: 90px;
            height: 90px;
            object-fit: contain;
            cursor: pointer;
            margin-top: 10px;
          }

          .telegram-icon {
            border-radius: 50%;
          }
          
          @media (max-width: 1024px) {
            .telegram-icon-container {
              bottom: 18px;
              left: 18px;
            }
            
            .social-icon { width: 92px; height: 92px; }
          }
          
          @media (max-width: 768px) {
            .telegram-icon-container {
              top: 50%;
              bottom: auto;
              right: 0%;
              left: auto;
              transform: translate(-50%, -50%);
            }
            .social-icon { width: 80px; height: 80px; }
          }
          
          @media (max-width: 480px) {
            .social-icon { width: 38px; height: 38px; gap: 10px;margin-top: 10px;}
          }
        `
      }} />
    </div>
  );
};

export default TelegramIcon;
